import { render, staticRenderFns } from "./InboxCStoPO.vue?vue&type=template&id=36208005&"
import script from "./InboxCStoPO.vue?vue&type=script&lang=js&"
export * from "./InboxCStoPO.vue?vue&type=script&lang=js&"
import style0 from "./InboxCStoPO.vue?vue&type=style&index=0&id=36208005&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports